var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board-canvas"},[_c('canvas',{ref:"canvasRef",attrs:{"width":"520px","height":"507px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }